<script setup lang="ts">
import FacebookIcon from "@/components/icons/FacebookIcon.vue";
import InstagramIcon from "@/components/icons/InstagramIcon.vue";
import YoutubeIcon from "@/components/icons/YoutubeIcon.vue";

withDefaults(defineProps<{ color?: string }>(), {
  color: "#76C100",
});

const items = [
  {
    title: "Facebook",
    icon: FacebookIcon,
    url: "https://www.facebook.com/profile.php?id=61562600300324",
  },
  {
    title: "Youtube",
    icon: YoutubeIcon,
    url: "https://www.youtube.com/@SimplyBroadband",
  },
  {
    title: "Instagram",
    icon: InstagramIcon,
    url: "https://www.instagram.com/simplybroadband/",
  },
];
</script>

<template>
  <div class="flex items-center gap-6">
    <a
      v-for="item in items"
      :key="item.title"
      :href="item.url"
      :title="item.title"
      target="_blank"
    >
      <component :is="item.icon" :color="color" />
    </a>
  </div>
</template>

<style scoped></style>
